<template>
  <div class="form-group">
    <div class="zip-code">
      <label>
        郵便番号
      </label>
      <br />
      <input
        class="form-control zipCode"
        type="number"
        v-model="zipCode"
        placeholder="1230872"
      />
      <div class="street-address">
        <label>都道府県</label>
        <span class="municipality">市区町村</span>
        <br />
        <input class="prefectures" type="text" placeholder="東京都" v-model="city"/>
        <input class="municipality-width" type="text" placeholder="千代田区" v-model="locality"/>
        <div class="form-group">
          <label>
            町名番地
          </label>
          <br />
          <input
            class="form-control"
            type="text"
            placeholder="神田神保町3-2-5"
            v-model="street"
          />
        </div>

        <div class="form-group">
          <label>
            建物名等
          </label>
          <br />
          <input
            class="form-control"
            type="text"
            placeholder="元気マンション  １０１"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let YubinBango = require("yubinbango-core2");
export default {
  data() {
    return {
      zipCode: null,
      city: null,
      locality: null,
      street: null
    };
  },
  watch: {
    zipCode: function(zipCode) {
      let _this = this;
      new YubinBango.Core(zipCode, function(addr) {
        _this.city = addr.region; // 都道府県
        _this.locality = addr.locality; // 市区町村
        _this.street = addr.street; // 町域
      });
    }
  }
};
</script>

<style>
.zipCode {
  width: 120px;
}
.prefectures {
  width: 120px;
  height: 30px;
  border-style: hidden;
  border-bottom: solid 1px;
  font-size: 25px;
  margin-left: 10px;
}
.municipality {
  margin-left: 50px;
  font-weight: bold;
  display: inline-block;
  font-size: 25px;
}
.municipality-width {
  width: 170px;
  height: 30px;
  border-style: hidden;
  border-bottom: solid 1px;
  margin-left: 30px;
  font-size: 25px;
}
</style>



// WEBPACK FOOTER //
// src/molecules/InputAddress.vue